import { createSelector } from 'reselect';

const selectDomain = (state) => state.get('brandRegistration');

export const selectImageType = createSelector(
  selectDomain,
  (state) => state.get('imageType'),
);

export const selectBrandOwners = createSelector(
  selectDomain,
  (state) => state.get('owners')
    .toJS()
    .sort((a, b) => {
      if (a.ownerNumber > b.ownerNumber) {
        return 1;
      }

      if (a.ownerNumber < b.ownerNumber) {
        return -1;
      }

      return 0;
    }),
);

export const selectEarMarks = createSelector(
  selectDomain,
  (state) => state.get('earMarks').toJS(),
);

export const selectPending = createSelector(
  selectDomain,
  (state) => state.get('pending'),
);

export const selectLoading = createSelector(
  selectDomain,
  (state) => state.get('loading'),
);


export const selectBrandImage = createSelector(
  selectDomain,
  (state) => {
    const registration = state.get('registration').toJS();

    return registration?.brandImage;
  },
);

export const selectBrandDescription = createSelector(
  selectDomain,
  (state) => {
    const {
      id,
      county,
      description,
    } = state.get('registration').toJS();

    return {
      id,
      county,
      description,
    };
  },
);

export const selectBrandPositions = createSelector(
  selectDomain,
  (state) => {
    const { positions } = state.get('registration').toJS();

    return positions || [];
  },
);

export const selectImageRegisteredPositions = createSelector(
  selectDomain,
  (state) => {
    const imageRegisteredPositions = state.get('imageRegisteredPositions').toJS();

    return imageRegisteredPositions || [];
  },
);

export const selectBrandAddress = createSelector(
  selectDomain,
  (state) => {
    const registration = state.get('registration').toJS();
    const owners = state.get('owners').toJS();
    const firstOwner = owners[0];

    if (
      registration?.zipcode &&
      registration?.lineOne &&
      registration?.city &&
      registration?.state &&
      registration?.county
    ) {
      return {
        lineOne: registration?.lineOne || '',
        lineTwo: registration?.lineTwo || '',
        city: registration?.city || '',
        state: registration?.state || 'UT',
        zipcode: registration?.zipcode || '',
        county: registration?.county || '',
      };
    }

    return {
      lineOne: firstOwner?.lineOne || '',
      lineTwo: firstOwner?.lineTwo || '',
      city: firstOwner?.city || '',
      state: firstOwner?.state || 'UT',
      zipcode: firstOwner?.zipcode || '',
      county: firstOwner?.county || '',
    };
  },
);

export const selectBrandError = createSelector(
  selectDomain,
  (state) => state.get('error'),
);
